/*
HOW TO
MAKE IMAGE ARRAY AND PASS TO preload.startLoad
------------------------------------------------
var imgarry = [];
for(var i = 0; i < 100; i++){
	imgarry.push("images/test/bg" + i + ".png");
}
preload.startLoad(100,imgarry).done(function(){
	console.log("all done")
});
*/

var preload = {
	count: 0,
	max : 0,
	hasLoading: 0,
	arry: [],
	startLoad: function(max,arry, hasLoading){
		var defer = $.Deferred();
		preload.count = 0;
		this.max = max;
		this.arry = arry;
		preload.hasLoading = hasLoading;
		var promise = this.load();
		
		promise.done(function(){
			defer.resolve();
		});
		return defer.promise();
	},
	load: function(){
		var defer 	= $.Deferred();
		loadImg();

		function loadImg(){
			var newImg = new Image();
			newImg.src = preload.arry[preload.count];
			newImg.onload = function(){
				preload.count++;

				if(preload.hasLoading === 1){
					var per = Math.floor(preload.count/preload.max*100) - 50;
					if(per < 0){
						per = 0;
					}
					$("#loading .l, #loading .r").css("width", per + "%");
				}
				if(preload.count < preload.max){
					loadImg();
				}else{
					$("#loading .l, #loading .r").css("width", "50%");
					defer.resolve();
				}
			}
		}
		return defer.promise();
	}
}

var preloadPage = {
	count: 0,
	max : 0,
	arry: [],
	startLoad: function(max,arry){
		var defer = $.Deferred();
		preloadPage.count = 0;
		this.max = max;
		this.arry = arry;
		var promise = this.load();

		promise.done(function(){
			defer.resolve();
		});
		return defer.promise();
	},
	load: function(){
		var defer 	= $.Deferred();
		loadImg();

		function load(_url){
			var xhr;
			xhr = new XMLHttpRequest();
			xhr.open("HEAD", _url, false);
			xhr.send(null);
			return xhr.status;
		}

		function loadImg(){
			/*
			var xhr;
			xhr = new XMLHttpRequest();
			xhr.open("HEAD", preloadPage.arry[preloadPage.count], false);
			xhr.send(null);
			*/
			if(preloadPage.count < preloadPage.max){
				var per = Math.floor(preloadPage.count/preloadPage.max*100) - 50;
				$("#loading .l, #loading .r").css("width", per + "%");
			}
			setTimeout(function(){
				preloadPage.count++;
				if(preloadPage.count < preloadPage.max){
					loadImg();
				}else{
					$("#loading .l, #loading .r").css("width", "50%");
					defer.resolve();
				}
			},Math.random()*100 + 20);
			/*
			if(xhr.status === 200){
				let newImg = new Image();
				let status = load(preloadPage.arry[preloadPage.count]);
				newImg.src = preloadPage.arry[preloadPage.count];
				newImg.onload = function(){
					preloadPage.count++;
					if(preloadPage.count < preloadPage.max){
						loadImg();
					}else{
						$("#loading .l, #loading .r").css("width", "50%");
						defer.resolve();
					}
				}
			}else{
				console.log(xhr.status, preloadPage.arry[preloadPage.count])
				//console.log(preload.arry)
				preloadPage.count++;
				if(preloadPage.count < preloadPage.max){
					loadImg();
				}else{
					defer.resolve();
				}
			}
			*/
		}
		return defer.promise();
	}
}